import { useMatchRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { routeStore } from "../../lib/store";
import type { VoidComponent } from "../../lib/types";

const RouteHelper: VoidComponent = () => {
	const matchRoute = useMatchRoute();
	const indexParams = matchRoute({ from: "/" });
	const pillarParams = matchRoute({ from: "/$pillar/" });
	const categoryParams = matchRoute({ from: "/$pillar/$category/" });
	const initiativeParams = matchRoute({ from: "/$pillar/$category/$initiative/" });

	useEffect(() => {
		if (indexParams) {
			routeStore.setState({ level: "index", params: false });
		}

		if (pillarParams) {
			routeStore.setState({ level: "pillar", params: pillarParams });
		}

		if (categoryParams) {
			routeStore.setState({ level: "category", params: categoryParams });
		}

		if (initiativeParams) {
			routeStore.setState({ level: "initiative", params: initiativeParams });
		}
	}, [indexParams, pillarParams, categoryParams, initiativeParams]);

	return null;
};

export { RouteHelper };
